import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const SubconceptIdsFunction: HelperFunction = {
	tokenName: 'SUBCONCEPT_IDS',
	nodeType: functionNodeTypes.SubconceptIds,
	evaluate(node, evaluateExpr, context) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('SUBCONCEPT_IDS function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('SUBCONCEPT_IDS function argument must evaluate to a string', node))
		}
		const concept = context.getConcept(result.value)
		if(!concept) {
			return err(evaluatorErrorWithNode(`SUBCONCEPT_IDS function expected concept for '${result.value}' but null`, node))
		}
		return ok(concept.subconcepts)
	}
}
